import { AppState } from 'reducers';

export const getCategoryById = (state: AppState, categoryId: string) =>
  state.categories[categoryId];
